import React from 'react';
import PropTypes from 'prop-types';
import { svgSprite } from '../../../../hybrid/wrappers';
import admin from '../../../../project/uikit/data-variables/office-volumes.module.scss';
import { t } from '../../../../common/components/T';
import css from './UserVolumes.module.scss';

export const transformVolumes = (personal_volume, group_volume, total_personal_volume, total_group_volume, trans) => [
    {
        alias: 'coin',
        volume: personal_volume || '0 PV',
        title: t('transformVolumesoneCoin', 'Личный объем', 'widget', trans, 'userModal')
    },
    {
        alias: 'coins',
        volume: group_volume || '0 PV',
        title: t('transformVolumestwoCoin', 'Групповой объем', 'widget', trans, 'userModal')
    },
    {
        alias: 'coin-plus',
        volume: total_personal_volume || '0 PV',
        title: t('transformVolumesoneCoinPlus', 'Накопительный личный объем', 'widget', trans, 'userModal')
    },
    {
        alias: 'coins-plus',
        volume: total_group_volume || '0 PV',
        title: t('CumulativeGroupVolumes', 'Накопительный групповой объем', 'widget', trans, 'userModal')
    }
];
const UserVolumes = ({ data, trans }) => {
    const volumes = transformVolumes(
        data?.marketing_profile?.total_personal_volume?.formatted_value,
        data?.marketing_profile?.total_group_volume?.formatted_value,
        data?.marketing_profile?.total_group_volume?.formatted_value,
        data?.marketing_profile?.total_group_volume?.formatted_value,
        trans
    );
    return volumes.map((volumeItem, idx) => (
        <div className={css.userModalVolumeItem} key={`userInfo${idx}`}>
            <div
                className={css.userModalInfoIcon}
                style={{
                    'background-color': admin[`officeVolumesColorTransparent_${idx}`]
                }}
            >
                {svgSprite(volumeItem.alias, {
                    fill: admin[`officeVolumesColor_${idx}`],
                    width: '20px',
                    height: '20px'
                })}
            </div>
            <div>
                <div className={css.userModalVolumeValue}>{volumeItem.volume}</div>
                <div className={css.userModalVolumeTitle}>{volumeItem.title}</div>
            </div>
        </div>
    ));
};
UserVolumes.propTypes = { volumes: PropTypes.array };

export default UserVolumes;
